import HomeView from 'views/home/HomeView';
import {GiccHome} from 'bridges/Home/Gicc';
import {hasVipDomain} from 'utils/common.util';

export default function HomeContainer() {
  return <>{hasVipDomain ? <GiccHome /> : <HomeView />}</>;
}
